import { realWorldPictureSize } from "@brickme/project-core/src/model/picture.ts";
import type { GenericSize } from "@brickme/project-core/src/model/geom.ts";
import type { Scene } from "@brickme/project-core/src/scenes/types.ts";

type DrawSizeConfiguration = {
	readonly minTotalMargin: number;
};

function createDrawSize(
	brickedDimensions: GenericSize<number>,
	{ width: parentWidth, height: parentHeight }: GenericSize<number>,
	scene: Scene | undefined,
	{ minTotalMargin }: DrawSizeConfiguration,
) {
	if (brickedDimensions.width === 0 || brickedDimensions.height === 0) {
		return { width: 0, height: 0 };
	}

	if (scene !== undefined) {
		const sceneWidth = scene.fullSize.realWorldSize.width.mm;
		const sceneHeight = scene.fullSize.realWorldSize.height.mm;
		const availableWidth = Math.max(0, parentWidth - minTotalMargin);
		const availableHeight = Math.max(0, parentHeight - minTotalMargin);
		const xScaleToContain = availableWidth / sceneWidth;
		const yScaleToContain = availableHeight / sceneHeight;
		const useScaleToContain = Math.min(xScaleToContain, yScaleToContain);
		const containedWidth = Math.floor(useScaleToContain * sceneWidth);
		const containedHeight = Math.floor(useScaleToContain * sceneHeight);
		return {
			width: containedWidth,
			height: containedHeight,
		};
	}

	const worldSize = realWorldPictureSize(brickedDimensions);
	const availableWidth = Math.max(0, parentWidth - minTotalMargin);
	const availableHeight = Math.max(0, parentHeight - minTotalMargin);
	const xScaleToContain = availableWidth / worldSize.width.mm;
	const yScaleToContain = availableHeight / worldSize.height.mm;
	const useScaleToContain = Math.min(xScaleToContain, yScaleToContain);
	const containedWidth = Math.floor(useScaleToContain * worldSize.width.mm);
	// Note: Unsure about brickSize here - seems to count frame dimensions
	const brickSize = Math.floor(containedWidth / brickedDimensions.width);

	const canvasWidth = brickSize * brickedDimensions.width;
	const canvasHeight = brickSize * brickedDimensions.height;
	return { width: canvasWidth, height: canvasHeight };
}

export { createDrawSize };
